'use client'

import {
  Box,
  Center,
  Flex,
  SimpleGrid,
  Stat,
  StatLabel,
  StatNumber,
  useColorModeValue,
  Heading, 
  Text,
  Wrap,
  WrapItem,
  Avatar
} from '@chakra-ui/react'
import { ReactNode } from 'react'
import { IoIosStats } from 'react-icons/io'
import { BiSolidPencil } from 'react-icons/bi'
import { BiSolidUserVoice } from 'react-icons/bi'
import { CheckCircleIcon } from '@chakra-ui/icons'
import { COLORS } from "../../../colors"
import FormModal from "./formModal"

export default function Nosotros() {
  return (
    <Flex flexDirection={"column"} mt={0} gap={2} align={"center"} justify={"center"} px={6}  py={{ base: 10, lg: 0 }} bgColor={COLORS.brand4}>
      <Heading textAlign={"center"} as="h2" size="xl" mt={5} mb={20} fontFamily={"Montserrat"}>
        Fundadores de Somerset Language Centre
      </Heading>
      <Wrap 
        spacing={{ base: 20, md: 40 }} 
        mb={30} 
        direction=  {{ base: 'column', sm: 'row', md: 'row' }}  // Responsivo: columna en pantallas pequeñas, fila en medianas y grandes
        align="center"
        justify="center"
      >
        <WrapItem>
          <Avatar size='2xl' name='Sara Hancock' src='/sara.jpeg' />
        </WrapItem>
        <WrapItem>
          <Avatar size='2xl' name='Hugo Hancock' src='/hugo.jpeg' />
        </WrapItem>
      </Wrap>
      <Text mt={1} textAlign={"center"} fontFamily={"Montserrat"} maxW={{ base: "100%", md: "70%" }}>
        Somos Hugo y Sara Hancock, fundadores del Somerset Language Centre. Con años de experiencia dedicados a la enseñanza de idiomas.
      </Text>
      <Text mt={1} textAlign={"center"} fontFamily={"Montserrat"} maxW={{ base: "100%", md: "70%" }}>
        Desde nuestros inicios, nuestro objetivo ha sido ofrecer una formación lingüística de alta calidad, adaptada a las necesidades y objetivos de cada estudiante. Creemos en la importancia de aprender nuevas lenguas para abrir puertas a nuevas oportunidades y culturas.
      </Text>
      <Text mt={1} mb={10} textAlign={"center"} fontFamily={"Montserrat"} maxW={{ base: "100%", md: "70%" }}>
        Nuestra pasión por la enseñanza y nuestro compromiso con nuestros alumnos nos ha permitido crecer y evolucionar, convirtiendo Somerset Language Centre en un lugar donde el aprendizaje es una experiencia enriquecedora y gratificante.
        Te invitamos a unirte a nuestra comunidad y descubrir el placer de aprender un nuevo idioma con nosotros.
      </Text>
    </Flex>
  )
}
